$(window).on('load', function () {
  // Remove the spinner
  $('.boutiques_spinner_v1_target').fadeOut();

  // Handle linking to specific sections
  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // Handle links...?mod[num]=boutique_mod[num]
  function scrollToLinkMod(linkNo) {
    if (getParameterByName('mod' + linkNo) === 'boutique_mod' + linkNo) {
      $('html, body')
        .delay(500)
        .animate(
          {
            scrollTop: $('#r4_mod' + linkNo).offset().top - 100
          },
          1500,
          'easeInOutQuad'
        );
    }
  }

  for (i = 2; i <= 6; i++) {
    scrollToLinkMod(i);
  }

  // Handle the hero animations
  $('#r4_hero_callout').css(
    {
      opacity: '0',
      top: '13.3%'
    },
    420
  );
  $('#r4_hero_h1').css(
    {
      opacity: '0',
      top: '20.2%'
    },
    420
  );
  $('#r4_hero_h2_1').css(
    {
      opacity: '0',
      top: '80.1%'
    },
    420
  );
  $('#r4_hero_h2_2').css(
    {
      opacity: '0',
      top: '83.1%'
    },
    420
  );
  $('#r4_hero_block_1').css(
    {
      opacity: '0',
      top: '89.1%'
    },
    420
  );

  $('#r4_hero_callout').delay(250).animate(
    {
      opacity: 1,
      top: '9.3%'
    },
    420
  );
  $('#r4_hero_h1').delay(250).animate(
    {
      opacity: 1,
      top: '4%'
    },
    420
  );
  $('#r4_hero_h2_1').delay(450).animate(
    {
      opacity: 1,
      top: '76.1%'
    },
    420
  );
  $('#r4_hero_h2_2').delay(650).animate(
    {
      opacity: 1,
      top: '79.2%'
    },
    420
  );
  $('#r4_hero_block_1').delay(850).animate(
    {
      opacity: 1,
      top: '85.1%'
    },
    420
  );
});

(function ($) {
  Drupal.behaviors.r4_formatter_mob_v1 = {
    attach: function (context, settings) {
      $('.r4_formatter_mob_v1', context).once('r4_formatter_mob_v1', function () {
        /** SETUP **/
        // Apply classes
        function makeBoutiqueChecks() {
          // Check for Windows.
          if (navigator.platform == 'Win32') {
            $('body').addClass('isWin');
          }

          // Check for Safari.
          if (
            navigator.userAgent.indexOf('Safari') != -1 &&
            navigator.userAgent.indexOf('Chrome') == -1
          ) {
            $('body').addClass('isSafari');
          }

          // Check for Firefox.
          var isFF = false;

          if (navigator.userAgent.search('Firefox') >= 0) {
            $('body').addClass('isFF');
            isFF = true;
          }

          // Check for IE.
          var isIE = false;

          if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
            isIE = true;
          }
          if (isIE) {
            if ($('body').hasClass('isTouch')) {
              $('body').removeClass('isTouch');
            }
          }

          // Check for mobile device
          var isMobile = false;

          if (
            /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
          ) {
            isMobile = true;
            $('body').addClass('isMobile');
          }

          // Check for iPad.
          var isTouch = false;

          if (navigator.userAgent.match(/iPad/i) != null) {
            isTouch = true;
            $('body').addClass('isTouch');
          }
        }
        makeBoutiqueChecks();

        /** ** SCROLLMAGIC FUNCTIONALITY ****/
        /** MODULE 3 **/
        // Reset elements
        function resetMod3() {
          $('.r4_reviews_slide').css({
            opacity: '0',
            'padding-top': '6%'
          });
        }
        resetMod3();

        // Handle single play-through
        var scene3FirstRun = true;

        // Animation
        function scene3() {
          if (scene3FirstRun) {
            $('.r4_reviews_slide').animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              450,
              'easeOutQuad',
              function () {
                scene3FirstRun = false;
              }
            );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline3 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline3 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod3',
          offset: -300
        })
          .on('start', function () {
            scene3();
          })
          .addTo(controllerTimeline3);

        /** MODULE 4 **/
        // Reset elements
        function resetMod4() {
          $('.r4_info_mob_section1, .r4_info_mob_section2, .r4_info_mob_section3').css({
            opacity: '0',
            'padding-top': '6%'
          });
        }
        resetMod4();

        // Handle single play-through
        var scene4FirstRun = true;

        // Animation
        function scene4() {
          if (scene4FirstRun) {
            $('.r4_info_mob_section1, .r4_info_mob_section2, .r4_info_mob_section3').animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              450,
              'easeOutQuad',
              function () {
                scene4FirstRun = false;
              }
            );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline4 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline4 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod4',
          offset: -300
        })
          .on('start', function () {
            scene4();
          })
          .addTo(controllerTimeline4);

        /** MODULE 6 **/
        // Reset elements
        function resetMod6() {
          $('#r4_mod6_h1').css({
            opacity: '0',
            'margin-top': '20%'
          });
        }
        resetMod6();

        // Handle single play-through
        var scene6FirstRun = true;

        // Animation
        function scene6() {
          if (scene6FirstRun) {
            $('#r4_mod6_h1').animate(
              {
                opacity: 1,
                marginTop: '0'
              },
              600,
              'easeOutQuad',
              function () {
                scene6FirstRun = false;
              }
            );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline6 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline6 = new ScrollMagic.Scene({
          triggerElement: '#r4_mod6',
          offset: 120
        })
          .on('start', function () {
            scene6();
          })
          .addTo(controllerTimeline6);

        // /** MPP MODULE **/
        // Reset elements
        function resetMod8() {
          $('#r4_mpp_labels_mob_mpp').parent().css({
            opacity: '0',
            'margin-top': '20%'
          });
        }
        resetMod8();

        // Handle single play-through
        var scene8FirstRun = true;

        // Animation
        function scene8() {
          if (scene8FirstRun) {
            $('#r4_mpp_labels_mob_mpp')
              .parent()
              .animate(
                {
                  opacity: 1,
                  marginTop: '0'
                },
                600,
                'easeOutQuad',
                function () {
                  scene8FirstRun = false;
                }
              );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline8 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline8 = new ScrollMagic.Scene({
          triggerElement: '#r4_mpp_labels_mob_mpp',
          offset: -200
        })
          .on('start', function () {
            scene8();
          })
          .addTo(controllerTimeline8);

        // /** OLAPIC MODULE **/
        // Reset elements
        function resetMod9() {
          $('.olapic-widget.olapic-widget-v1').css({
            opacity: '0',
            'margin-top': '20%'
          });
        }
        resetMod9();

        // Handle single play-through
        var scene9FirstRun = true;

        // Animation
        function scene9() {
          if (scene9FirstRun) {
            $('.olapic-widget.olapic-widget-v1').animate(
              {
                opacity: 1,
                marginTop: '0'
              },
              600,
              'easeOutQuad',
              function () {
                scene9FirstRun = false;
              }
            );
          } else {
            return;
          }
        }

        // Init scrollMagic Controller Class
        var controllerTimeline9 = new ScrollMagic.Controller();
        // Init scrollMagic Scene Class
        var sceneTimeline9 = new ScrollMagic.Scene({
          triggerElement: '.olapic-widget.olapic-widget-v1',
          offset: -200
        })
          .on('start', function () {
            scene9();
          })
          .addTo(controllerTimeline9);
        /** ** VIDEO FUNCTIONALITY ****/
        // Orientation checks for player styling.
        var iosCheck = false;

        if (navigator.userAgent.match(/iPhone|iPod/i) != null) {
          iosCheck = true;
          $('body').addClass('isIOS');
        }

        function detectInitialOrientation() {
          if (iosCheck === true) {
            if ($(window).height() < $(window).width()) {
              $('#r4_mod2_video, #r4_mod6_video').addClass('isLandscape');
            } else if ($(window).height() < $(window).width()) {
              if ($('#r4_mod2_video, #r4_mod6_video').hasClass('isLandscape')) {
                $('#r4_mod2_video, #r4_mod6_video').removeClass('isLandscape');
              }
            }
          } else if (iosCheck === false) {
            if ($(window).height() < $(window).width()) {
              $('#r4_mod2_video, #r4_mod6_video').addClass('isLandscape');
            } else if ($(window).height() > $(window).width()) {
              if ($('#r4_mod2_video, #r4_mod6_video').hasClass('isLandscape')) {
                $('#r4_mod2_video, #r4_mod6_video').removeClass('isLandscape');
              }
            }
          }
        }
        detectInitialOrientation();

        function detectOrientationChange() {
          if (iosCheck === true) {
            if (window.innerHeight < window.innerWidth) {
              $('#r4_mod2_video, #r4_mod6_video').addClass('isLandscape');
            } else if (window.innerHeight > window.innerWidth) {
              if ($('#r4_mod2_video, #r4_mod6_video').hasClass('isLandscape')) {
                $('#r4_mod2_video, #r4_mod6_video').removeClass('isLandscape');
              }
            }
          } else if (iosCheck === false) {
            if (window.innerHeight > window.innerWidth) {
              $('#r4_mod2_video, #r4_mod6_video').addClass('isLandscape');
            } else if (window.innerHeight < window.innerWidth) {
              if ($('#r4_mod2_video, #r4_mod6_video').hasClass('isLandscape')) {
                $('#r4_mod2_video, #r4_mod6_video').removeClass('isLandscape');
              }
            }
          }
        }
        $(window).on('orientationchange', function (event) {
          detectOrientationChange();
        });

        // Players.
        var player1;
        // Video Sources.
        var src1 = 'Klmt6IQhVZQ';
        // Initialise YouTube API.
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];

        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Execute as soon as the player API is ready.
        onYouTubeIframeAPIReady = function () {
          player1 = new YT.Player('r4_mod2_video_container', {
            videoId: src1,
            playerVars: {
              enablejsapi: 1,
              autohide: 1,
              autoplay: 0,
              cc_load_policy: 0,
              controls: 0,
              disablekb: 0,
              end: 0,
              wmode: 'transparent',
              fs: 1,
              loop: 0,
              html5: 1,
              playsinline: 1
            },
            events: {
              onReady: playerOneReady
            }
          });
        };

        // When the Players are ready.
        var duration1, videoInterval1;
        var close1 = $('#r4_mod2 .boutique__video_close_x');
        var playTrigger1 = $('#r4_mod2 .r4_video_tvc_play, #r4_mod2 .r4_video_tvc_cta');

        function playerOneReady() {
          duration1 = player1.getDuration();
          videoInterval1 = $('#r4_mod2_video .boutique__video_inner_scrubber');
        }

        // Play the videos.
        function playEach(theNum, eachPlayerNum, eachInterval, eachDuration, eachClose, eachEnd) {
          $('#r4_mod' + theNum + '_video .boutique__video_close_x').show();
          $('#r4_mod' + theNum + '_video').fadeIn();
          $('#r4_mod' + theNum + '_video_container').show();
          scrubberAndPlay(eachPlayerNum, eachInterval, eachDuration, eachClose, eachEnd);
        }

        playTrigger1.click(function () {
          playEach(2, player1, videoInterval1, duration1, close1, 1);
        });

        // Handle the scrubber.
        function scrubberAndPlay(playerNum, vidInterval, duration, close, closeTime) {
          playerNum.seekTo(0, true);
          playerNum.playVideo();

          vidInterval = setInterval(function () {
            var currentTime = playerNum.getCurrentTime(),
              multipliedTime = (currentTime / duration) * 100 + 3;

            if (currentTime >= duration - closeTime) {
              close.click();

              return;
            }
          }, 30);
        }

        // Close the videos.
        function closePlayer(whichPlayer, playerNum, whichInterval) {
          whichPlayer.pauseVideo();
          whichPlayer.stopVideo();
          $('#r4_mod' + playerNum + '_video_container').hide();
          $('#r4_mod' + playerNum + '_video .boutique__video_close_x').hide();
          clearInterval(whichInterval);
          $('#r4_mod' + playerNum + ' .boutique__video_top_video').fadeOut();
        }

        close1.click(function () {
          closePlayer(player1, 2, videoInterval1);
        });
      });
    }
  };
})(jQuery);
